import { styled } from 'baseui'

export const StyledContainer = styled('div', () => ({
  width: '100%',
  padding: '0rem',
}))

export const UpdatedAt = styled('span', ({ $theme }) => ({
  flexGrow: 1,
  flexBasis: 0,
  minWidth: 0,
  paddingLeft: '0.5rem',
  fontSize: '0.6875rem',
  lineHeight: '1rem',
  color: $theme.colors.white,
  opacity: 0.84,
  textAlign: 'right',
}))

export const MessageList = styled('div', ({ $hidden }) => ({
  display: $hidden ? 'none' : 'flex',
  flexDirection: 'column',
  paddingTop: '0.125rem',
  paddingBottom: '0.25rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
}))

export const MessageRow = styled('div', ({ $theme }) => ({
  display: 'flex',
  gap: '0.625rem',
  paddingTop: '0.6875rem',
  paddingBottom: '0.6875rem',
  borderBottom: `1px solid ${$theme.colors.borderPulse}`,
  ':last-child': { borderBottom: 0 },
}))

export const MessageDot = styled('span', ({ $theme }) => ({
  flexShrink: 0,
  width: '0.375rem',
  height: '0.375rem',
  marginTop: '0.4375rem',
  borderRadius: '999px',
  backgroundColor: $theme.colors.primaryPulse,
}))

export const CommunicationNote = styled('div', ({ $theme }) => ({
  flexGrow: 1,
  minWidth: 0,
  fontSize: '0.8125rem',
  lineHeight: '1.45',
  color: $theme.colors.textPulseLabel,
  overflowWrap: 'anywhere',
  '& p': { marginTop: 0, marginBottom: '0.375rem' },
  '& p:last-child': { marginBottom: 0 },
  '& ul, & ol': { marginTop: '0.25rem', marginBottom: '0.375rem', paddingLeft: '1.1rem' },
  '& ul:last-child, & ol:last-child': { marginBottom: 0 },
  '& li': { marginBottom: '0.125rem' },
  '& a': { color: $theme.colors.primary },
  '& strong, & b': { fontWeight: 600, color: $theme.colors.textHeading },
}))

export const StyledEmptyState = styled('div', ({ $theme }) => ({
  fontStyle: 'italic',
  fontSize: '0.8125rem',
  color: $theme.colors.textLight,
  textAlign: 'center',
  marginTop: '0.75rem',
  marginBottom: '1rem',
  marginLeft: '1rem',
  marginRight: '1rem',
}))
